export const LOCAL_DELIVERY_HINT =
  'Oba! Frete grátis! Nossa equipe entrará em contato para combinar a entrega o mais rápido possível.';

export const LOCAL_DELIVERY_BANNER =
  'Frete grátis — entrega pela nossa equipe em São José dos Campos';
